<template>
  <main class="travel">
    <section class="hero-full-bleed">
      <h1>Travel</h1>
    </section>

    <section class="top">
      <div class="padded-lg accomm">
        <h3 class="desktop">Accommodations</h3>
        <h3 class="mobile">Lodging</h3>
        <div class="hotel-list">
          <div class="hotel">
            <p class="subheading-serif">Hotel Dylan</p>
            <p class="body-md body-md--light">320 Maverick Rd<br>Woodstock, NY 12498</p>
            <p class="body-md body-md--light">(845) 684-5422</p>
            <a href="https://thehoteldylan.com/" target="_blank" rel="noopener noreferrer" class="body-md body-md--medium arrow-link">Check Rates</a>
          </div>
          <div class="hotel">
            <p class="subheading-serif">Woodstock Way</p>
            <p class="body-md body-md--light">10 Waterfall Way<br>Woodstock, NY 12498</p>
            <p class="body-md body-md--light">(845) 684-5911</p>
            <a href="https://www.woodstockway.com/" target="_blank" rel="noopener noreferrer" class="body-md body-md--medium arrow-link">Check Rates</a>
          </div>
          <div class="hotel">
            <p class="subheading-serif">Diamond Mills</p>
            <p class="body-md body-md--light">25 S Partition St<br>Saugerties, NY 12477</p>
            <p class="body-md body-md--light">(845) 247-0700</p>
            <p class="body-md body-md--light dm">Room Block Full</p>
          </div>
          <div class="hotel">
            <p class="subheading-serif">Holiday Inn Express</p>
            <p class="body-md body-md--light">2777 NY-32<br>Saugerties, NY 12477</p>
            <p class="body-md body-md--light">(845) 247-8800</p>
            <p class="body-md body-md--light dm">Sold Out</p>
          </div>
        </div>
        <p class="body-lg">Beyond this list, there are plenty of lovely hotels and <a href="https://www.airbnb.com/s/Saugerties--New-York--United-States/homes?tab_id=home_tab&refinement_paths%5B%5D=%2Fhomes&flexible_trip_lengths%5B%5D=one_week&monthly_start_date=2024-05-01&monthly_length=3&monthly_end_date=2024-08-01&price_filter_input_type=0&channel=EXPLORE&query=Saugerties%2C%20NY&place_id=ChIJu9HgefMI3YkR1jphgp8t5dc&date_picker_type=calendar&checkin=2024-10-04&checkout=2024-10-06" target="_blank" rel="noopener noreferrer" class="body-lg">Airbnbs</a> in the area. We highly recommend booking accommodations as soon as possible as our wedding coincides with peak tourism season in the Hudson Valley.</p>
      </div>
      <div class="padded-lg travel">
        <h3>Travel to NY</h3>
        <p class="body-lg">For guests who aren’t within convenient driving distance of Saugerties, the nearest airport to fly to is <a href="https://www.albanyairport.com/" target="_blank" rel="noopener noreferrer">Albany International Airport (ALB)</a>, situated just a 45-minute drive away. Airports in the NYC area are approximately a two-hour drive from Saugerties. If you plan to extend your stay in the region before or after the wedding, we highly recommend renting a car.</p>
        <br>
        <p class="body-lg">For guests coming from New York City, <a href="https://trailways.com/" target="_blank" rel="noopener noreferrer">Trailways</a> operates multiple buses daily from Port Authority to Saugerties. Roundtrip tickets typically range from $50 to $70.</p>
      </div>
    </section>

    <section class="padded-lg bottom">
      <h3>Things To Do</h3>
      <div class="cards">
          <div class="card">
            <p class="subheading-serif">Cafés</p>
            <ul>
              <li class="body-md body-md--light"><a href="https://goo.gl/maps/3c1BxkvXMw6DEWVdA" target="_blank" rel="noopener noreferrer">Bluestone Coffee Roasting Co.</a></li>
              <li class="body-md body-md--light"><a href="https://goo.gl/maps/dL6tnv2J6uGNRWoh9" target="_blank" rel="noopener noreferrer">Olsen & Company</a></li>
              <li class="body-md body-md--light"><a href="https://goo.gl/maps/oKmynuNznGvJF4B67" target="_blank" rel="noopener noreferrer">Caffe</a></li>
              <li class="body-md body-md--light"><a href="https://goo.gl/maps/UUkQneZxeERFVDrDA" target="_blank" rel="noopener noreferrer">The Mud Club</a></li>
              <li class="body-md body-md--light"><a href="https://goo.gl/maps/7G35qcdi4wX38Dqd6" target="_blank" rel="noopener noreferrer">Village Coffee and Goods</a></li>
            </ul>
          </div>

          <div class="card">
            <p class="subheading-serif">Restaurants</p>
            <ul>
              <li class="body-md body-md--light"><a href="https://goo.gl/maps/MHyKAt9inkGwLEwt6" target="_blank" rel="noopener noreferrer">Miss Lucy’s Kitchen</a></li>
              <li class="body-md body-md--light"><a href="https://goo.gl/maps/A1EgTMcToQnYSqRM6" target="_blank" rel="noopener noreferrer">Main Street</a></li>
              <li class="body-md body-md--light"><a href="https://goo.gl/maps/5b5HVU1F6RC3W3dV8" target="_blank" rel="noopener noreferrer">Mirabella’s</a></li>
              <li class="body-md body-md--light"><a href="https://goo.gl/maps/4pYACoZr2oC35Cqm7" target="_blank" rel="noopener noreferrer">Le Canard Enchaine</a></li>
              <li class="body-md body-md--light"><a href="https://goo.gl/maps/6UQU9tn4jWdf8d9u9" target="_blank" rel="noopener noreferrer">LOLA</a></li>
            </ul>
          </div>

          <div class="card">
            <p class="subheading-serif">Bars</p>
            <ul>
              <li class="body-md body-md--light"><a href="https://goo.gl/maps/HnuYNCCiKdzjhJnLA" target="_blank" rel="noopener noreferrer">The Partition Bar</a></li>
              <li class="body-md body-md--light"><a href="https://goo.gl/maps/wbYa4MbtuKvDcrTf9" target="_blank" rel="noopener noreferrer">The Dutch</a></li>
              <li class="body-md body-md--light"><a href="https://goo.gl/maps/zRRMpQesPv1tzNtf8" target="_blank" rel="noopener noreferrer">Traghaven Whiskey Pub & Co.</a></li>
              <li class="body-md body-md--light"><a href="https://goo.gl/maps/8qHaywy6uhUadkDP6" target="_blank" rel="noopener noreferrer">Station Bar & Curio</a></li>
              <li class="body-md body-md--light"><a href="https://goo.gl/maps/nNQvyaxBQfmFwLJZ9" target="_blank" rel="noopener noreferrer">Catskill Mountain Moonshine Co.</a></li>
            </ul>
          </div>

          <div class="card">
            <p class="subheading-serif">Misc.</p>
            <ul>
              <li class="body-md body-md--light"><a href="https://goo.gl/maps/kpfPm6pMKvuqgb4d6" target="_blank" rel="noopener noreferrer">Hudson River Maritime Museum</a></li>
              <li class="body-md body-md--light"><a href="https://goo.gl/maps/hd1mrN6xEx4AJivF9" target="_blank" rel="noopener noreferrer">Forsyth Nature Center</a></li>
              <li class="body-md body-md--light"><a href="https://goo.gl/maps/D33rZXkmHwc5swq19" target="_blank" rel="noopener noreferrer">Falling Waters Preserve</a></li>
              <li class="body-md body-md--light"><a href="https://goo.gl/maps/Jjsa8MdU2BVsMihb6" target="_blank" rel="noopener noreferrer">Saugerties Antique Center</a></li>
              <li class="body-md body-md--light"><a href="https://goo.gl/maps/yBHZjBmwiVcFbHd98" target="_blank" rel="noopener noreferrer">Rough Draft Bar & Books</a></li>
            </ul>
          </div>
        </div>
    </section>
  </main>
</template>

<script>
export default {
    methods: {
      showModal() {
        this.$store.dispatch('toggleModal', true, { root: true })
      },
    }
}
</script>

<style lang="scss" scoped>
  .hero-full-bleed {
    background-image: url('~@/assets/img/travel-01.jpg');
    color: $color-shade-100;
  }

  section.bottom a {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  h3 {
    margin-bottom: $space-7;
  }

  .top {
    align-items: stretch;
    border-bottom: $border-900-md;
    border-top: $border-900-md;
    display: flex;
    flex-direction: column;
    justify-content: stretch;

    @include min-width(lg) {
      flex-direction: row;
    }
  }

  .accomm {
    background-color: $color-neutral-400;
    flex: 2;

    .desktop {
      display: none;

      @include min-width(tablet) {
        display: block;
      }
    }

    .mobile {
      @include min-width(tablet) {
        display: none;
      }
    }

    .hotel-list {
      margin-bottom: $space-7;
    }

    .hotel {
      align-items: flex-start;
      border-bottom: $border-900-sm;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: $space-2 0;
      text-align: left;

      &:nth-child(3),
      &:nth-child(4) {
        opacity: .45;
      }

      .subheading-serif {
        margin: 0 0 $space-2 0;
      }

      a.body-md.body-md--medium,
      .button-link,
      .body-md.body-md--light.dm {
        margin: $space-2 0 0 0;
        color: $color-shade-900;
      }

      .button-link {
        background-color: transparent;
        border: none;
        padding: 0;

        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }

      @include min-width(tablet) {
        align-items: center;
        flex-direction: row;

        .subheading-serif {
          margin: 0;
          min-width: 190px;
        }

        a.body-md.body-md--medium,
        .button-link,
        .body-md.body-md--light.dm {
          margin: 0;
          min-width: 140px;
          text-align: right;
        }
      }
    }
  }

  .travel {
    flex: 1;

    @include min-width(lg) {
      border-left: $border-900-md;
    }
  }

  .bottom {
    align-items: center;
    background-color: $color-shade-900;
    color: $color-shade-100;
    display: flex;
    flex-direction: column;
    justify-content: stretch;

    .cards {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      gap: $space-6;
      justify-content: flex-start;
      max-width: 1070px;

      @include min-width(tablet) {
        justify-content: center;
      }
    }

    .card {
      align-items: stretch;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      @include min-width(tablet) {
        border: $border-100-sm;
        padding: $space-3;
      }

      @include min-width(desktop) {
        padding: $space-5;
      }

      @include min-width(lg) {
        flex-direction: row;
      }

      .subheading-serif {
        margin-bottom: $space-4;

        @include min-width(tablet) {
          min-width: 140px;
        }
      }

      ul {
        @include min-width(tablet) {
          min-width: 255px;
        }
      }

      a {
        color: $color-shade-100;
      }
    }
  }

  // [data-popover='diamond-mills'] {
  //   padding: $space-3;

  //   @media only screen and (max-width: 833px) {
  //     left: 10px !important;
  //     width: 300px !important;

  //     &::before {
  //       left: calc(20% - 6px);
  //     }
  //   }

  //   @include min-width(tablet) {
  //     width: 260px !important;
  //   }
  // }
</style>